const actions = {
  //- Sets the current apprentice
  setSelectedApplication({ commit }, application) {
    //- Mutate store
    commit('SET_APPLICATION', application)
  },
  updateSelectedApplication({ commit }, application) {
    //- Mutate store
    commit('UPDATE_APPLICATION', application)
  },
  setCurrentStep({ commit }, currentStep) {
    //- Mutate store
    commit('SET_CURRENTSTEP', currentStep)
  },
  setHaveEducation({ commit }, bool) {
    commit('SET_EDUCATION', bool)
  }
}

export default actions
